'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp;

var _reactRedux = require('react-redux');

var _voice_code = require('redux/actions/voice_code');

var _user = require('redux/actions/user');

var _payment = require('redux/actions/payment');

var _helpers = require('helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    VoiceCode: {
        displayName: 'VoiceCode'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/VoiceCode/VoiceCode.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var VoiceCode = _wrapComponent('VoiceCode')((_dec = (0, _reactRedux.connect)(function (state) {
    return {
        is_send_voice_code: state.voiceCode.is_send_voice_code,
        timerRepeat: state.voiceCode.timerRepeat,
        error: state.voiceCode.error,
        errorPassRecovery: state.passRecovery.error,
        currentTime: state.voiceCode.currentTime,
        preloader: state.voiceCode.preloader,
        lang: state.lang
    };
}, { sendVoiceCode: _voice_code.sendVoiceCode, resetVoiceCode: _voice_code.resetVoiceCode, resetError: _user.resetError, startTimer: _voice_code.startTimer, resetPaymentIbonus: _payment.resetPaymentIbonus }), _dec(_class = (_temp = _class2 = function (_Component) {
    (0, _inherits3.default)(VoiceCode, _Component);

    function VoiceCode(props) {
        (0, _classCallCheck3.default)(this, VoiceCode);

        var _this = (0, _possibleConstructorReturn3.default)(this, (VoiceCode.__proto__ || (0, _getPrototypeOf2.default)(VoiceCode)).call(this, props));

        _this.onCallbackVoice = function (event) {
            event.preventDefault();
            _this.props.resetError();
            _this.props.resetPaymentIbonus();
            _this.props.sendVoiceCode(_this.props.login, _this.props.source, _this.props.phone);
        };

        _this.timer = function () {
            _this.props.startTimer(_this.props.timerRepeat);
        };

        _this.showOuterAlert = function () {
            _this.props.showAlert(_this.alert);
        };

        _this.alert = null;
        return _this;
    }

    (0, _createClass3.default)(VoiceCode, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var messageStart = this.props.lang['store.voice_code.message.start'];
            var messageEnd = this.props.lang['store.voice_code.message.end'];

            if (nextProps.error && nextProps.error !== this.props.error) {

                this.alert = {
                    message: this.props.lang[nextProps.error],
                    style: 'danger'
                };
            } else if (nextProps.is_send_voice_code === true && this.props.is_send_voice_code !== nextProps.is_send_voice_code) {

                this.alert = {
                    message: messageStart + ' ' + this.props.timerRepeat + ' ' + messageEnd, style: 'success'
                };
                this.timer();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.props.resetVoiceCode();
        }
    }, {
        key: 'render',
        value: function render() {
            var View = _helpers.ThemeHelper.getViewForComponent('VoiceCode');

            return _react3.default.createElement(View, {
                alert: this.alert,
                onCallbackVoice: this.onCallbackVoice,
                sendVoiceTime: this.props.timerRepeat,
                showAlert: this.showOuterAlert,
                currentTime: this.props.currentTime,
                preloader: this.props.preloader,
                lang: this.props.lang
            });
        }
    }]);
    return VoiceCode;
}(_react2.Component), _class2.propTypes = {
    lang: _react2.PropTypes.object
}, _class2.defaultProps = {}, _temp)) || _class));

exports.default = VoiceCode;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/VoiceCode/VoiceCode.jsx
// module id = 1787
// module chunks = 0